import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {InvoiceReportData} from "./invoice-report.data";

@Injectable()
export class InvoiceReportModel extends ReportModel<InvoiceReportData> {
    constructor(injector: Injector) {
        super(injector, InvoiceReportData)
    }
}
